import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync, faWarning } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import NoticeBox from '@components/NoticeBox'

interface DataSourceChangedNoticeProps {
  callbacks: {
    recalculateQuoteTemplatePrices: VoidFunction,
  },
  updating: boolean,
}

const DataSourceChangedNotice = (props: DataSourceChangedNoticeProps) => {
  const {
    callbacks: {
      recalculateQuoteTemplatePrices,
    },
    updating,
  } = props

  return (
    <NoticeBox
      footer={(
        <NoticeBox.Footer>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faSync} />}
            loading={updating}
            onClick={recalculateQuoteTemplatePrices}
            size="small"
            width="auto"
          >
            Recalculate Prices
          </Button>
        </NoticeBox.Footer>
      )}
      icon={<FontAwesomeIcon icon={faWarning} />}
    >
      <NoticeBox.Title>Campaign Data Source Changed</NoticeBox.Title>

      <NoticeBox.Paragraph>
        The campaign assigned to the quote template has changed. Would you like to recalculate prices?
      </NoticeBox.Paragraph>
    </NoticeBox>
  )
}

export default DataSourceChangedNotice
